import { useEffect, useState } from "react";
import {
  DraftVariations,
  GenerateCampaignResponse,
} from "../types/creator-studio";
import { normalizeSocialDraftText } from "../utils/social-draft";
import { isNotEmpty } from "../utils/type-utils";

export const useSelectVariation = (
  generatedCampaign: GenerateCampaignResponse | null,
  initialSelectedVariation?: DraftVariations | null
) => {
  const [selectedVariation, setSelectedVariation] = useState<number | null>(1);
  const [variations, setVariations] = useState<DraftVariations[]>([]);

  useEffect(() => {
    if (isNotEmpty(generatedCampaign) && isNotEmpty(generatedCampaign.drafts)) {
      const drafts = generatedCampaign.drafts.map((draft) => ({
        ...draft,
        body: normalizeSocialDraftText(draft.body),
      }));
      setVariations(drafts);
      const initial = initialSelectedVariation;
      if (isNotEmpty(initial)) {
        const index = drafts.findIndex((d) => d.id === initial.id);
        setSelectedVariation(
          index >= 0 ? index : (generatedCampaign.preferred_variation ?? 1)
        );
      } else {
        setSelectedVariation(generatedCampaign.preferred_variation ?? 1);
      }
    }
  }, [generatedCampaign, initialSelectedVariation]);

  return { selectedVariation, setSelectedVariation, variations };
};

// {
//   "variations": [
//     {
//       "subject": "HootSuite: Elevate Your Social Media Management",
//       "body": "HootSuite helps you elevate your social media management. Founded in 2008, the platform enables teams to manage their presence across networks from a single dashboard.\n\nFrom scheduling posts to advanced analytics, HootSuite covers it all. With OwlyWriter AI for content creation and Social Listening powered by Talkwalker, you can craft messages that resonate with your audience.\n\nWhether you’re a solo developer or part of a larger team, the intuitive interface and comprehensive educational resources make mastering social media management straightforward.\n\nDiscover how HootSuite can transform your strategy. Learn more: https://influencermarketinghub.com/hootsuite/ #SocialMedia #HootSuite #Marketing",
//       "id": 1,
//       "label": "VARIATION A",
//       "color": "blue",
//       "focus": "All-in-one platform features, AI-driven content, and social listening for teams of any size"
//     },
//     {
//       "subject": "HootSuite: Unlock the Full Potential of Your Social Media Strategy",
//       "body": "HootSuite unlocks the full potential of your social media strategy. As a leading management platform since 2008, we help businesses streamline social media activities across networks such as Facebook, Instagram, Twitter, and beyond.\n\nOur advanced features, including OwlyWriter AI and Social Listening insights, empower you to create compelling content and engage your audience effectively.\n\nDesigned for everyone from solo developers to large enterprises, HootSuite offers an intuitive interface and comprehensive learning resources to keep you ahead in the digital landscape.\n\nDiscover how HootSuite can elevate your social media management. Learn more: https://influencermarketinghub.com/hootsuite/ #SocialMediaManagement #HootSuite",
//       "id": 2,
//       "label": "VARIATION B",
//       "color": "purple",
//       "focus": "Cross-network management with AI-driven content and rich learning resources"
//     },
//     {
//       "subject": "HootSuite: Streamline Your Social Media Management",
//       "body": "HootSuite helps you streamline social media management. Since 2008, we have provided tools to help businesses manage their online presence efficiently.\n\nWith features such as automated publishing, robust analytics, and OwlyWriter AI, you can create and share standout content. Our Social Listening capability provides valuable insights into your audience’s behaviors and preferences.\n\nIdeal for solo developers and software product companies, HootSuite is user-friendly and backed by extensive learning resources to help you succeed.\n\nElevate your social media strategy. Learn more: https://influencermarketinghub.com/hootsuite/ #DigitalMarketing #HootSuite",
//       "id": 3,
//       "label": "VARIATION C",
//       "color": "orange",
//       "focus": "Automation, analytics, and audience insights for developers and software product companies"
//     }
//   ],
//   "preferred_index": 2
// }
